import { sidebarConstants } from "../_constants";

export const sidebarOn = device => ({
  type: sidebarConstants.SIDEBAR_ON,
  device
});

export const sidebarOff = () => ({
  type: sidebarConstants.SIDEBAR_OFF
});



// WEBPACK FOOTER //
// ./src/_actions/sidebar.actions.js